import { Crew } from '@src/main/modules/ibdp/domain/crew.interface';

export type SCOption = {
  name: string;
  surname: string;
  payrollNumber: string;
  label?: string;
};

export const mapCrewToSCOption = (crew: Crew[]): SCOption[] =>
  crew.map((c) => ({
    name: c.name,
    surname: c.surnames ?? '',
    payrollNumber: c.payrollNumber ?? '',
    label: `${c.name} ${c.surnames} (${c.payrollNumber})`,
  }));
